export const pathMapping = {
  "Sponsored Display": "SD",
  "Sponsored Brand": "SB",
  "Sponsored Product": "SP",
  DSP: "DSP",
};

export const pathLabelMapping = {
  SD: {
    label: "Sponsored Display",
    opacity: 1,
  },
  SB: { label: "Sponsored Brand", opacity: 0.9 },
  SP: { label: "Sponsored Product", opacity: 0.8 },
  DSP: { label: "DSP", opacity: 0.7 },
  ST: { label: "Streaming TV", opacity: 0.6 },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const castNumbersInRowData = (rowData: any) => {
  const isNumericString = (value: string): boolean => /^-?\d+(\.\d+)?$/.test(value.trim());
  if (typeof rowData === "object" && rowData !== null) {
    const keys = Object.keys(rowData);

    for (const key of keys) {
      rowData[key] = castNumbersInRowData(rowData[key]);
    }
  } else if (typeof rowData === "string" && isNumericString(rowData)) {
    return Number(rowData);
  }

  return rowData;
};
